<template>
	<div class="text-white px-3 py-2 border border-0 border-dark d-flex flex-fill" >
		<div class="bg-dark px-0 pt-4 rounded-3 shadow d-flex flex-column align-items-center position-relative" style="min-width: 300px;">
			<div v-if="image" class="review-profile p-5 bg-secondary border rounded-circle" :style="{
				'background-image': `radial-gradient(rgba(0,0,0,0.1), rgba(0,0,0,0.7)), url(${image})`
			}">
                <div class="p-3"></div>
            </div>
			<div class="review-profile p-5 bg-secondary border rounded-circle" v-else>
                <div class="p-3"></div>
            </div>
			<div class="py-4 px-4 fw-lighter flex-fill d-flex flex-column justify-content-center">
				<i class="bi bi-quote"></i>
                <small>{{quote}}</small>
            </div>
			<div class="position-relative w-100">
				<div class="py-0">
					<i class="bi bi-star-fill text-warning mx-1" v-for="star in stars" :key="star"></i>
					<i class="bi bi-star text-warning mx-1" v-for="star in (new Array( 5-(stars.length) ))" :key="star"></i>
				</div>
				<div class="py-0 position-absolute start-0 bottom-0">
					<div class="py-0 px-2 bg-warning-subtle shadow">
						<span class="text-dark fw-bolder">{{revieweeName}}</span>
					</div>
				</div>
			</div>
			<div class="py-3">
				<span style="cursor: pointer;" @click="openLinkedIn">
					<i class="bi bi-linkedin"></i> LinkedIn
				</span>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "ReviewCard",
	props: {
		revieweeName: String,
		quote: String,
		image: String,
		stars: Array,
		linkedin: String
	},
	methods: {
		openLinkedIn(){
			window.open(this.linkedin, "_blank").focus();
		}
	}
}
</script>
<style scoped>
.review-profile {
	background-position: top;
	background-size: cover;
}
</style>